<script>
import LoadingComponent from "@/components/LoadingComponent.vue";
import DateFilterComponent from "@/components/LayananTransaksi/DateFilterComponent.vue";
import ReportSummaryComponent from "@/components/LayananTransaksi/Pendapatan/ReportSummaryComponent.vue";
import RevenueGraphComponent from "@/components/LayananTransaksi/Pendapatan/RevenueGraphComponent.vue";
import TableStyleComponentTotal from "@/components/LayananTransaksi/Pendapatan/TableStyleComponentTotal.vue";
import TableStyleComponentDetail from "@/components/LayananTransaksi/Pendapatan/TableStyleComponentDetail.vue";
import WarningUploadCTP from "@/components/LayananTransaksi/Alert/WarningUploadCTP.vue";
import Cookies from "js-cookie";
import * as constant from "@/constants/constant";

export default {
  components: {
    WarningUploadCTP,
    LoadingComponent,
    DateFilterComponent,
    ReportSummaryComponent,
    RevenueGraphComponent,
    TableStyleComponentTotal,
    TableStyleComponentDetail,
  },
  data() {
    const account = JSON.parse(Cookies.get("loginResponse"));
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 2);
    return {
      account: account,
      constant: constant,
      loading: false,
      start_date: firstDayOfMonth.toISOString().split("T")[0],
      end_date: today.toISOString().split("T")[0],
      formatted_date_range: "",
      selectedPeriod: "daily",
      selectedGate: [
        "jk1",
        "jku1",
        "nagrak",
        "narogong",
        "burangkeng",
        "stu1",
        "cibitung6",
        "cibitung7",
        "tlga",
        "gabus",
        "marunda",
        "trmj",
        "jk2",
        "jku2",
        "stu2",
      ],
      reportData: null,
      checkedCtp: null,
      fetchDebounceTimeout: null,
      alert: true,
      uploadDialog: false,
      confirmUploadDialog: false, // New confirmation dialog state
      monthReconciledDialog: false, // New dialog for already reconciled month
      selectedFile: null,
      isDragging: false,
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
      message: "",
      selectedMonth: null,
      selectedYear: null,
      password: "",
      months: [
        { value: 1, label: "Januari" },
        { value: 2, label: "Februari" },
        { value: 3, label: "Maret" },
        { value: 4, label: "April" },
        { value: 5, label: "Mei" },
        { value: 6, label: "Juni" },
        { value: 7, label: "Juli" },
        { value: 8, label: "Agustus" },
        { value: 9, label: "September" },
        { value: 10, label: "Oktober" },
        { value: 11, label: "November" },
        { value: 12, label: "Desember" },
      ],
      years: [],
    };
  },
  computed: {
    filteredMonths() {
      // Only allow up to previous month if current year is selected
      const today = new Date();
      if (this.selectedYear === today.getFullYear()) {
        const prevMonth = today.getMonth(); // 0-based, so June is 5, May is 4
        return this.months.filter((m) => m.value <= prevMonth);
      }
      return this.months;
    },
    formattedGate() {
      return this.selectedGate.join(",");
    },
    fetchParams() {
      return {
        from: this.start_date,
        to: this.end_date,
        gates: this.formattedGate,
        graph_type: this.selectedPeriod,
      };
    },
  },
  watch: {
    fetchParams: {
      handler() {
        if (
          this.start_date &&
          this.end_date &&
          this.selectedPeriod &&
          this.selectedGate.length > 0
        ) {
          this.fetchData();
        }
      },
      deep: true,
    },
    selectedYear() {
      // If selectedMonth is not available in filteredMonths, reset to max allowed month
      const allowedMonths = this.filteredMonths.map((m) => m.value);
      if (!allowedMonths.includes(this.selectedMonth)) {
        this.selectedMonth = allowedMonths[allowedMonths.length - 1];
      }
    },
  },
  methods: {
    // Add a proper reset function to handle file upload states
    resetUploadState() {
      this.selectedFile = null;
      this.password = "";
      this.uploadDialog = false;
      this.confirmUploadDialog = false;

      // Reset the file input element
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }

      this.isDragging = false;
    },
    async uploadFile() {
      try {
        // First verify the password
        const loginPayload = {
          nik: this.account.nik,
          password: this.password,
        };

        try {
          await this.$axios.post("/verify", loginPayload);
          // Password is verified, now show confirmation dialog
          this.confirmUploadDialog = true;
        } catch (error) {
          this.snackbarText = "Password salah. Silakan coba lagi.";
          this.snackbarColor = "error";
          this.snackbar = true;
          return;
        }
      } catch (error) {
        console.error("Verification error:", error);
        this.snackbarText = "Terjadi kesalahan. Silakan coba lagi.";
        this.snackbarColor = "error";
        this.snackbar = true;
      }
    },
    async confirmAndUploadFile() {
      try {
        const formData = new FormData();
        formData.append("excel_file", this.selectedFile);
        formData.append("month", this.selectedMonth);
        formData.append("year", this.selectedYear);

        const response = await this.$axios.post("/upload-reconcile", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        // Use the reset function instead of manually resetting each state
        this.resetUploadState();

        // Show success message
        this.message = response.data.status;
        this.snackbarText = "File berhasil diunggah";
        this.snackbarColor = "white";
        this.snackbar = true;
      } catch (error) {
        // Check for specific error message
        const errorMessage = error?.response?.data?.message || "";

        if (errorMessage.includes("Bulan yang dipilih sudah direkonsiliasi")) {
          this.monthReconciledDialog = true; // Show special dialog instead of snackbar
          this.confirmUploadDialog = false; // Close confirmation dialog
        } else {
          this.snackbarText =
            errorMessage || "Gagal mengunggah file. Silakan coba lagi.";
          this.snackbarColor = "error";
          this.snackbar = true;
        }
        console.error("Upload error:", error);
        this.confirmUploadDialog = false;
      }
    },
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      const files = e.dataTransfer.files;

      if (files.length > 0) {
        const file = files[0];
        if (file.name.endsWith(".xlsx")) {
          this.selectedFile = file;
          this.isDragging = false;
        }
      }
    },
    clearSelectedFile() {
      this.selectedFile = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },
    onChange() {
      const inputElement = this.$refs.fileInput;
      if (inputElement && inputElement.files && inputElement.files.length > 0) {
        this.selectedFile = inputElement.files[0];
      }
    },
    updateStartDate(newDate) {
      if (this.start_date !== newDate) {
        this.start_date = newDate;
      }
    },
    updateEndDate(newDate) {
      if (this.end_date !== newDate) {
        this.end_date = newDate;
        // this.initialLoad = false;
      }
    },
    updateFormattedDateRange(newRange) {
      this.formatted_date_range = newRange;
    },
    updatePeriod(newPeriod) {
      if (this.selectedPeriod !== newPeriod) {
        this.selectedPeriod = newPeriod;
      }
    },
    updateGate(newGate) {
      if (JSON.stringify(this.selectedGate) !== JSON.stringify(newGate)) {
        this.selectedGate = newGate;
      }
    },
    async fetchData() {
      this.loading = true;
      try {
        const response = await this.$axios.get("gate-incomes", {
          params: this.fetchParams,
        });
        this.reportData = response.data;
        this.loading = false;
      } catch (error) {
        console.error("Error fetching data:", error);
        this.loading = false;
      }
    },
    initializeYearOptions() {
      const today = new Date();
      const currentYear = today.getFullYear();
      this.years = [];
      for (let i = 0; i < 10; i++) {
        this.years.push(currentYear - i);
      }
      // Default to current year
      this.selectedYear = currentYear;
      // Default to previous month (h-1)
      this.selectedMonth = today.getMonth(); // getMonth() is 0-based, so this is previous month
      if (this.selectedMonth === 0) {
        // If January, set to December previous year
        this.selectedMonth = 12;
        this.selectedYear = currentYear - 1;
      }
    },
    closeMonthReconciledDialog() {
      this.monthReconciledDialog = false;
      // Also reset when closing this dialog
      this.resetUploadState();
    },
  },
  mounted() {
    this.fetchData();
    this.initializeYearOptions();
  },
};
</script>

<template>
  <div class="pa-0 ma-0">
    <v-row v-if="loading" justify="center" align="center" style="height: 100vh">
      <LoadingComponent />
    </v-row>

    <!-- Content -->
    <div :class="loading ? 'none' : ''">
      <div class="pb-3 pt-4 px-10">
        <v-row no-gutters>
          <v-col
            align="left"
            class="my-auto pe-5"
            cols="12"
            xs="12"
            sm="12"
            md="7"
          >
            <WarningUploadCTP
              :start_date="this.start_date"
              :end_date="this.end_date"
            />
          </v-col>
          <v-col align="right" class="my-auto" cols="12" xs="12" sm="12" md="5">
            <v-sheet>
              <v-row no-gutters>
                <v-col align="left" class="my-auto" cols="2">
                  <v-sheet>
                    <span
                      class="text--black text-uppercase"
                      style="font-size: 12px; font-weight: 400; color: #bbbbbb"
                      >Filter</span
                    >
                    <h6
                      class="text--black"
                      style="font-size: 14px; font-weight: 400"
                    >
                      Pilih Tanggal
                    </h6>
                  </v-sheet>
                </v-col>
                <v-col align="right" class="my-auto" cols="10">
                  <v-sheet>
                    <DateFilterComponent
                      @update:startDate="updateStartDate"
                      @update:endDate="updateEndDate"
                      @update:formattedDateRange="updateFormattedDateRange"
                    />
                  </v-sheet>
                </v-col>
              </v-row>
              <v-row no-gutters class="mt-4">
                <v-col align="right" class="my-auto" cols="12">
                  <div class="d-flex justify-end">
                    <v-btn
                      :disabled="
                        this.account.scopes.includes(
                          constant.SCOPES.view_transaction
                        ) &&
                        !this.account.scopes.includes(
                          constant.SCOPES.manage_transaction
                        )
                      "
                      @click="uploadDialog = true"
                      class="mr-4 text-capitalize text-body-2 white--text rounded-xl"
                      style="background-color: #004643"
                      variant="outlined"
                      elevation="1"
                    >
                      <span class="white--text">Upload Rekonsiliasi</span>
                      <v-icon right>mdi-upload</v-icon>
                    </v-btn>
                    <v-btn
                      class="text-capitalize text-body-2 text--black white rounded-xl"
                      variant="outlined"
                      elevation="1"
                      to="/layanan-transaksi/history-rekonsiliasi"
                    >
                      <v-icon>mdi-history</v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>
        </v-row>
      </div>

      <div>
        <!-- summary -->
        <ReportSummaryComponent
          v-if="reportData && reportData.summary"
          :data="reportData.summary"
        />
        <!-- revenue -->
        <RevenueGraphComponent
          v-if="reportData && reportData.graph"
          :data="reportData.graph"
          @update:selectedPeriod="updatePeriod"
          @update:selectedGate="updateGate"
          :averageReconcile="
            reportData.summary.total_reconcile / reportData.graph.length
          "
          :average="reportData.summary.average"
        />
        <div class="pb-3 pt-4 px-10">
          <!-- Detail Section -->
          <div class="mb-5 rounded-xl py-4 px-6 text-center bordered">
            <h3
              style="font-size: 18px; font-weight: 500"
              class="text-uppercase"
            >
              Detail
            </h3>
          </div>
          <div class="py-5">
            <v-row class="mb-4">
              <v-col cols="9" class="my-auto">
                <h3
                  class="text--black"
                  style="font-size: 20px; font-weight: 500"
                >
                  {{ formatted_date_range }}
                </h3>
              </v-col>
            </v-row>
            <TableStyleComponentTotal
              v-if="reportData && reportData.details.sum_all_gates"
              :data="reportData.details.sum_all_gates"
            />
            <div v-if="reportData && reportData.details">
              <template v-for="item in reportData.details.gate_list">
                <div :key="item.gate_code">
                  <TableStyleComponentDetail :data="item" />
                </div>
              </template>
            </div>
          </div>

        </div>
      </div>
    </div>
    <v-dialog v-model="uploadDialog" width="auto">
      <v-card class="px-10 py-10 rounded-xl">
        <v-layout row wrap>
          <h1 style="font-size: 1.5rem; font-weight: 700">
            Unggah File Rekonsiliasi
          </h1>
        </v-layout>
        <div class="d-flex align-center mt-8 mb-6" style="gap: 24px">
          <span style="font-size: 1.1rem; font-weight: 500"
            >Pilih Bulan Rekonsiliasi</span
          >
          <v-select
            v-model="selectedMonth"
            :items="filteredMonths"
            item-text="label"
            item-value="value"
            dense
            outlined
            hide-details
            style="min-width: 180px; max-width: 200px; margin-right: 12px"
            prepend-inner-icon="mdi-calendar-month"
          />
          <v-select
            v-model="selectedYear"
            :items="years"
            dense
            outlined
            hide-details
            style="min-width: 120px; max-width: 140px"
            prepend-inner-icon="mdi-calendar"
          />
        </div>
        <img
          style="cursor: pointer; position: absolute; top: 32px; right: 32px"
          @click="uploadDialog = false"
          :src="require('../../assets/icons/ph_x-bold.svg')"
        />
        <div
          class="dropzone-container"
          @dragover.prevent="dragover"
          @dragleave.prevent="dragleave"
          @drop.prevent="drop"
          ref="dropzone"
        >
          <input
            type="file"
            name="file"
            id="fileInput"
            class="hidden-input"
            @change="onChange"
            ref="fileInput"
            accept=".xlsx, .xls"
          />

          <label
            for="fileInput"
            class="file-label"
            style="color: #abb5be; font-size: 16px; width: 50vw"
          >
            <div v-if="isDragging">Drag file disini</div>
            <div
              v-else-if="!selectedFile"
              style="display: flex; flex-direction: column"
              class="justify-center align-center"
            >
              <img
                :src="require('../../assets/icons/material-symbols_folder.svg')"
                style="width: 32px; height: auto"
                class="mb-1"
              />
              <div style="color: #abb5be; font-size: 16px">
                <u style="color: #004643; font-size: 16px">Cari</u> atau drag
                file untuk unggah rekonsiliasi disini
              </div>
            </div>
            <div
              class="preview-container flex-column text-center"
              v-if="selectedFile"
            >
              <img
                :src="require('../../assets/icons/material-symbols_folder.svg')"
                style="width: 56px; height: auto; margin: 10px auto"
                class="mb-2"
              />
              <div class="mb-2" style="color: #004643; font-size: 16px">
                {{ selectedFile.name }}
              </div>
              <div
                class="d-flex align-center justify-center mb-4"
                style="gap: 16px; width: 100%"
              >
                <span
                  style="font-size: 1rem; min-width: 200px; text-align: right"
                >
                  Masukkan Password Anda
                </span>
                <v-text-field
                  v-model="password"
                  type="password"
                  outlined
                  dense
                  hide-details
                  style="max-width: 240px"
                  class="my-0"
                ></v-text-field>
              </div>

              <v-btn
                color="#004643"
                class="ma-2 white--text px-8 py-2 rounded-md mx-auto"
                @click="uploadFile"
              >
                Upload <v-icon right dark class="ml-2">mdi-upload</v-icon>
              </v-btn>
            </div>
          </label>
        </div>
      </v-card>
    </v-dialog>

    <!-- Confirmation Dialog -->
    <v-dialog v-model="confirmUploadDialog" width="500" persistent>
      <v-card class="pa-6 rounded-xl">
        <v-card-title class="text-h6 text-center">
          Pastikan Data Benar
        </v-card-title>

        <v-card-text> Anda yakin data yang anda unggah benar? </v-card-text>

        <v-card-actions class="pt-4">
          <v-row no-gutters>
            <v-col cols="6" class="pr-1">
              <v-btn
                block
                outlined
                class="rounded-lg"
                color="grey"
                @click="confirmUploadDialog = false"
              >
                Batal
              </v-btn>
            </v-col>
            <v-col cols="6" class="pl-1">
              <v-btn
                block
                color="#004643"
                class="white--text rounded-lg"
                @click="confirmAndUploadFile"
              >
                Upload
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Month Already Reconciled Dialog -->
    <v-dialog v-model="monthReconciledDialog" width="500" persistent>
      <v-card class="pa-6 rounded-xl">
        <v-card-title class="text-h6 font-weight-medium pb-4">
          Bulan yang dipilih sudah direkonsiliasi
        </v-card-title>

        <v-card-text class="py-4">
          Silakan hubungi admin untuk perbaikan data.
        </v-card-text>

        <v-card-actions class="pt-4 justify-end">
          <v-btn
            color="#004643"
            class="white--text px-6 rounded-lg"
            @click="closeMonthReconciledDialog"
          >
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="2500" top>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<style scoped>
.bordered {
  background-color: #dae7ff;
  border-left: 4px solid #497bdd;
  border-right: 4px solid #497bdd;
}
</style>

<!-- <style>
.no-scrollbar {
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none; /* Firefox */
}

.no-scrollbar::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
}
</style> -->
